<template>
  <b-card
    v-if="lookupOptions !== null && defaults !== null"
    :title="$t('settings.defaults')"
  >
    <b-card-body class="p-0">
      <b-form class="mt-1">
        <b-row>

          <!-- Status Filter -->
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              :label="$t('contributors.filter-status-label')"
              label-for="statusFilter"
            >
              <div class="d-flex align-items-center justify-content-end">
                <v-select
                  v-model="defaults.contributorStatus"
                  :options="lookupOptions.statusOptions"
                  class="w-100"
                  :placeholder="$t('contributors.filter-status')"
                  :reduce="val => val.label"
                />
              </div>
            </b-form-group>
          </b-col>
          <!-- Donations Type Filter -->
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              :label="$t('donations.filter-donations-label')"
              label-for="donationsTypeFilter"
            >
              <v-select
                v-model="defaults.donationsType"
                :options="lookupOptions.donationsTypeOptions"
                class="w-100"
                :placeholder="$t('donations.filter-donations')"
                :reduce="val => val.label"
              />
            </b-form-group>
          </b-col>
          <!-- Payments Filter -->
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              :label="$t('donations.filter-payments-label')"
              label-for="paymentsTypeFilter"
            >
              <v-select
                v-model="defaults.paymentsType"
                :options="lookupOptions.paymentsTypeOptions"
                :placeholder="$t('donations.filter-payments')"
                :reduce="val => val.label"
              />
            </b-form-group>
          </b-col>
          <!-- Category Type Filter -->
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              :label="$t('donations.filter-category-label')"
              label-for="categoryFilter"
            >
              <v-select
                v-model="defaults.category"
                :options="lookupOptions.categoryOptions"
                :placeholder="$t('donations.filter-category')"
                :reduce="val => val.label"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <b-form-group
              :label="$t('contributors.address-state')"
              label-for="state"
              label-class="mb-1"
            >
              <b-form-radio-group
                id="state"
                v-model="defaults.state"
                :options="lookupOptions.stateOptions"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group
              :label="$t('donations.currency')"
              label-for="currency"
              label-class="mb-1"
            >
              <b-form-radio-group
                id="currency"
                v-model="defaults.currency"
                :options="lookupOptions.currencyOptions"
              />
            </b-form-group>
          </b-col>

          <b-col
            cols="12"
            md="12"
          >
            <b-form-group>
              <label><span>{{ $t('projects.list-tasks') }} </span>
                <b-link
                  class="text-nowrap"
                  @click="switchDragging()"
                >
                  <feather-icon
                    icon="RepeatIcon"
                    size="16"
                  />
                </b-link></label>
              <b-form-tags
                v-if="!isDragging"
                v-model="defaults.tasks"
                input-id="tasks"
              />
              <draggable
                v-if="isDragging"
                :list="defaults.tasks"
                :group="{name:'tags', pull:'clone', put:false }"
                class="mb-1 cursor-move  bordered draggable"
              >
                <b-badge
                  v-for="(listItem, index) in defaults.tasks"
                  :key="index"
                  class="mr-25"
                  variant="primary"
                >
                  <small> {{ listItem }}</small>
                </b-badge>
              </draggable>

            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BFormGroup, BFormRadioGroup, BForm, BFormTags, BBadge, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'

export default {
  components: {
    BRow, BCol, BCard, BCardBody, BForm, BFormGroup, BFormRadioGroup, BFormTags, vSelect, draggable, BBadge, BLink,
  },
  props: {
    defaults: {
      type: Object,
      default: null,
    },
    lookupOptions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isDragging: false,
    }
  },
  methods: {
    switchDragging() { this.isDragging = !this.isDragging },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.draggable .badge {
  margin:0.45rem;
}
</style>
